var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb cmp-product-thumb--grid",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        {
          staticClass: "thumb-inner",
          class: _vm.paddingClasses,
          style: _vm.paddingInlineStyles
        },
        [
          _c("div", [
            _c(
              "div",
              { class: _vm.item.variation.isMain ? "isMain" : "isNotMain" },
              [
                _c("add-to-basket", {
                  attrs: {
                    "data-testing": "item-add-to-basket",
                    "variation-id": _vm.item.variation.id,
                    "is-salable":
                      !!_vm.item.filter && _vm.item.filter.isSalable,
                    "has-children":
                      !!_vm.item.item &&
                      _vm.item.item.salableVariationCount > 1,
                    "interval-quantity":
                      _vm.item.variation.intervalOrderQuantity || 1,
                    "minimum-quantity": _vm.item.variation.minimumOrderQuantity,
                    "maximum-quantity":
                      !!_vm.item.variation.maximumOrderQuantity &&
                      _vm.item.variation.maximumOrderQuantity > 0
                        ? _vm.item.variation.maximumOrderQuantity
                        : null,
                    "order-properties": _vm.item.properties.filter(function(
                      prop
                    ) {
                      return prop.property.isOderProperty
                    }),
                    "has-order-properties": _vm.item.hasOrderProperties,
                    "use-large-scale": true,
                    "show-quantity": false,
                    "item-url": _vm._f("itemURL")(
                      _vm.item,
                      _vm.urlWithVariationId
                    ),
                    "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
                    "item-type": _vm.item.item.itemType
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "thumb-background" }),
          _vm._v(" "),
          _c("div", { staticClass: "thumb-image" }, [
            _c("div", { staticClass: "square-container" }, [
              _c(
                "div",
                { staticClass: "square-inner main-image" },
                [
                  _vm._t("item-image", function() {
                    return [
                      _c("category-image-carousel", {
                        ref: "categoryImageCarousel",
                        attrs: {
                          "image-urls-data": _vm._f("itemImages")(
                            _vm.item.images,
                            _vm.imageUrlAccessor
                          ),
                          alt: _vm._f("itemName")(_vm.item),
                          title: _vm._f("itemName")(_vm.item),
                          "item-url": _vm._f("itemURL")(
                            _vm.item,
                            _vm.urlWithVariationId
                          ),
                          "enable-carousel":
                            _vm.$ceres.config.item.enableImageCarousel,
                          "disable-carousel-on-mobile":
                            _vm.disableCarouselOnMobile
                        }
                      })
                    ]
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _vm._t("store-special", function() {
            return [
              _vm.storeSpecial ||
              _vm.item.variation.bundleType === "bundle" ||
              _vm.item.item.itemType === "set"
                ? _c("item-store-special", {
                    attrs: {
                      "store-special": _vm.storeSpecial,
                      "recommended-retail-price": _vm.item.prices.rrp,
                      "variation-retail-price": _vm.item.prices.default,
                      "special-offer-price": _vm.item.prices.specialOffer,
                      "decimal-count": _vm.decimalCount,
                      "bundle-type": _vm.item.variation.bundleType,
                      "item-type": _vm.item.item.itemType
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _vm._t("item-details text-center", function() {
            return [
              _c(
                "div",
                {
                  staticClass: "item-details-wrapper",
                  on: {
                    click: function($event) {
                      return _vm.redirect()
                    }
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "thumb-content",
                      attrs: {
                        href: _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        )
                      }
                    },
                    [
                      _c("span", { staticClass: "thumb-title" }, [
                        _vm._v(_vm._s(_vm._f("itemName")(_vm.item)))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "thumb-title small" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.item.texts.name2) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "thumb-meta" },
                    [
                      _vm._t("before-prices"),
                      _vm._v(" "),
                      _c("div", { staticClass: "prices" }, [
                        _vm.item.prices.rrp &&
                        _vm.item.prices.rrp.price.value > 0 &&
                        _vm.item.prices.rrp.price.value >
                          _vm.item.prices.default.unitPrice.value
                          ? _c("div", { staticClass: "price-view-port" }, [
                              _vm.item.prices.specialOffer
                                ? _c("del", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.default.unitPrice
                                              .formatted,
                                            true
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                : _c("del", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.rrp.unitPrice
                                              .formatted
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "price" }, [
                          !_vm.item.variation.isMain
                            ? _c("span", [
                                _vm._v(
                                  "\n                                ab\n                            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm._f("specialOffer")(
                                  _vm.item.prices.default.unitPrice.formatted,
                                  _vm.item.prices,
                                  "unitPrice",
                                  "formatted"
                                )
                              ) +
                              " *\n                        "
                          )
                        ])
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn btn-outline-primary mt-3 home-thumb-btn"
                    },
                    [
                      _vm._v(
                        "\n                    Details anzeigen\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._t("after-prices"),
                  _vm._v(" "),
                  !(
                    _vm.item.unit.unitOfMeasurement === "C62" &&
                    _vm.item.unit.content === 1
                  )
                    ? _c("div", { staticClass: "category-unit-price" }, [
                        _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.item.unit.names.name))
                        ]),
                        _vm._v(" "),
                        _vm.item.variation.mayShowUnitPrice
                          ? _c("span", [
                              _vm._v(
                                " | " +
                                  _vm._s(_vm.item.prices.default.basePrice)
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      {
                        class: _vm.item.variation.isMain
                          ? "isMain"
                          : "isNotMain"
                      },
                      [
                        _c("add-to-basket", {
                          attrs: {
                            "variation-id": _vm.item.variation.id,
                            "is-salable":
                              !!_vm.item.filter && _vm.item.filter.isSalable,
                            "has-children":
                              !!_vm.item.item &&
                              _vm.item.item.salableVariationCount > 1,
                            "interval-quantity":
                              _vm.item.variation.intervalOrderQuantity || 1,
                            "minimum-quantity":
                              _vm.item.variation.minimumOrderQuantity,
                            "maximum-quantity":
                              !!_vm.item.variation.maximumOrderQuantity &&
                              _vm.item.variation.maximumOrderQuantity > 0
                                ? _vm.item.variation.maximumOrderQuantity
                                : null,
                            "order-properties": _vm.item.properties.filter(
                              function(prop) {
                                return prop.property.isOderProperty
                              }
                            ),
                            "has-order-properties": _vm.item.hasOrderProperties,
                            "use-large-scale": false,
                            "show-quantity": false,
                            "item-url": _vm._f("itemURL")(
                              _vm.item,
                              _vm.urlWithVariationId
                            ),
                            "has-price": _vm._f("hasItemDefaultPrice")(
                              _vm.item
                            ),
                            "item-type": _vm.item.item.itemType
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "availability-title small" }, [
                    _vm._v("Lieferzeit: ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class:
                        "availability small availability_" +
                        _vm.item.variation.availability.id
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.item.variation.availability.names.name) +
                          "\n                "
                      )
                    ]
                  )
                ],
                2
              )
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }